<template>
  <div class="corset-step-one">
    <v-layout
      hide-details
      justify-space-between
      class="mb-0"
    >
      <v-flex
        hide-details
        sm3
        class="mb-0"
      >
        <v-switch
          v-model="form.idc_corset"
          hide-details
          label="Corset :"
          class="title"
          @change="form.type_corset = null"
        />
      </v-flex>
      <v-flex
        hide-details
        sm9
        class="mb-0"
      >
        <v-switch
          v-model="form.idc_taking_measurement"
          hide-details
          label="Prise de mesure :"
          class="title"
          @change="clearMesuresFields"
        />
      </v-flex>
    </v-layout>

    <v-layout
      justify-space-between
      class="mb-0"
    >
      <v-flex
        hide-details
        sm3
        class="mb-0 mt-0"
      >
        <v-radio-group
          v-model="form.type_corset"
          hide-details
          class="mb-0 mt-0"
          :disabled="!form.idc_corset"
        >
          <v-radio
            class="mb-3 mt-1"
            hide-details
            label="CTM"
            value="CTM"
          />
          <v-radio
            class="mb-3"
            hide-details
            label="Boston"
            value="BOSTON"
          />
          <v-radio
            class="mb-3"
            hide-details
            label="Garchois"
            value="GARCHOIS"
          />
          <v-radio
            class="mb-3"
            hide-details
            label="Lombostat"
            value="LOMBOSTAT"
          />
          <v-radio
            class="mb-3"
            hide-details
            label="Anticyphose"
            value="ANTICYPHOSE"
          />
          <v-radio
            class="mb-3"
            hide-details
            label="Autres"
            value="OTHER"
          />
        </v-radio-group>
      </v-flex>

      <v-flex
        sm3
        hide-details
        class="mb-0 mt-0"
      >
        <v-radio-group
          v-model="form.type_measurement"
          hide-details
          class="mb-0 mt-0"
          :disabled="!form.idc_taking_measurement"
        >
          <v-radio
            class="mb-3 mt-1"
            hide-details
            label="Moulage platre"
            value="PLASTER_MOULDING"
          />
          <v-radio
            class="mb-3"
            hide-details
            label="Scanner"
            value="SCANNER"
          />
          <v-radio
            class="mb-3"
            hide-details
            label="Mesures"
            value="MEASURES"
          />
        </v-radio-group>
      </v-flex>

      <v-flex
        sm6
        hide-details
      >
        <v-radio-group
          v-model="form.lombar"
          hide-details
          class="mb-4 mt-1"
          row
          :disabled="!form.idc_taking_measurement"
        >
          <v-radio
            hide-details
            label="Lombaire"
            value="LOMBAR"
          />
          <v-radio
            hide-details
            label="Thoraco-Lombaire"
            value="THORACO_LOMBAR"
          />
          <v-radio
            hide-details
            class="mt-3 mb-0"
            label="CTM"
            value="CTM"
          />
        </v-radio-group>
        <v-textarea
          v-model="form.observation"
          hide-details
          filled
          name="Observation :"
          label="Observation :"
          :disabled="!form.idc_taking_measurement"
        />
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex
        justify-space-between
        row
      >
        <v-flex sm3>
          <v-checkbox
            v-model="form.idc_sternal_support"
            hide-details
            class="mt-0 mb-5 ml-3"
            label="APPUI STERNAL"
            :disabled="!form.idc_taking_measurement"
          />
        </v-flex>
        <v-flex>
          <v-checkbox
            v-model="form.idc_bi_clavicular_support"
            hide-details
            class="mt-0 mb-0 ml-6"
            label="APPUI BI CLAVICULAIRE"
            :disabled="!form.idc_taking_measurement"
          />
        </v-flex>
      </v-flex>
    </v-layout>

    <v-layout
      justify-space-between
      hide-details
      class="mb-6"
    >
      <v-flex sm6>
        <v-btn
          block
          @click="$emit('corset-sketch')"
        >
          Dessin CORSET
        </v-btn>
      </v-flex>
      <v-flex sm6>
        <v-btn
          block
          @click="$emit('cutout-sketch')"
        >
          Dessin DECOUPE
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout
      justify-center
      class="mb-4"
    >
      <h3>INFORMATIONS :</h3>
    </v-layout>
    <v-layout justify-space-between>
      <v-flex sm3>
        <v-select
          v-model="form.butt"
          :items="dropdowns.butt"
          item-text="label"
          item-value="value"
          label="Fesses"
          filled
          clearable
        />
      </v-flex>
      <v-flex sm3>
        <v-select
          v-model="form.belly"
          :items="dropdowns.belly"
          item-text="label"
          item-value="value"
          label="Ventre"
          filled
          clearable
        />
      </v-flex>
      <v-flex sm3>
        <v-select
          v-model="form.chest"
          :items="dropdowns.chest"
          item-text="label"
          item-value="value"
          label="Poitrine"
          filled
          clearable
        />
      </v-flex>
      <v-checkbox
        v-model="form.idc_sagging_chest"
        class="mb-1 mt-0"
        label="Tombante"
        hide-details
        :disabled="!form.chest"
      />
    </v-layout>

    <v-layout justify-center>
      <v-flex
        sm10
        mb-6
        mt-1
      >
        <div class="content">
          <div class="img-container">
            <img src="@/assets/img/schema_corset_1a.svg">

            <v-text-field
              v-model="form.h"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) H"
              :class="{ error: errors.has('(Schéma) H') }"
              outlined
              type="number"
              style="top:31.4%;left: 2.1%;"
              height="100%"
            />
            <v-text-field
              v-model="form.i"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) I"
              :class="{ error: errors.has('(Schéma) I') }"
              outlined
              type="number"
              style="top: 69.6%;left: 2.1%;"
              height="100%"
            />

            <v-text-field
              v-model="form.a1"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) A1"
              :class="{ error: errors.has('(Schéma) A1') }"
              outlined
              type="number"
              style="top: 10.2%;left: 43.3%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.a2"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) A2"
              :class="{ error: errors.has('(Schéma) A2') }"
              outlined
              type="number"
              style="top: 20.5%;left: 43.3%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.a3"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) A3"
              :class="{ error: errors.has('(Schéma) A3') }"
              outlined
              type="number"
              style="top: 31.3%;left: 43.3%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.a4"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) A4"
              :class="{ error: errors.has('(Schéma) A4') }"
              outlined
              type="number"
              style="top: 42.5%;left: 43.3%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.a5"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) A5"
              :class="{ error: errors.has('(Schéma) A5') }"
              outlined
              type="number"
              style="top: 56.1%;left: 43.3%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.a6"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) A6"
              :class="{ error: errors.has('(Schéma) A6') }"
              outlined
              type="number"
              style="top: 69.5%;left: 43.3%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.a7"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) A7"
              :class="{ error: errors.has('(Schéma) A7') }"
              outlined
              type="number"
              style="top: 82.8%;left: 43.3%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.b1"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) B1"
              :class="{ error: errors.has('(Schéma) B1') }"
              outlined
              type="number"
              style="top: 10.2%;left: 56.1%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.b2"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) B2"
              :class="{ error: errors.has('(Schéma) B2') }"
              outlined
              type="number"
              style="top: 20.5%;left: 56.1%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.b3"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) B3"
              :class="{ error: errors.has('(Schéma) B3') }"
              outlined
              type="number"
              style="top: 31.3%;left: 56.1%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.b4"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) B4"
              :class="{ error: errors.has('(Schéma) B4') }"
              outlined
              type="number"
              style="top: 42.5%;left: 56.1%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.b5"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) B5"
              :class="{ error: errors.has('(Schéma) B5') }"
              outlined
              type="number"
              style="top: 56.1%;left: 56.1%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.b6"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) B6"
              :class="{ error: errors.has('(Schéma) B6') }"
              outlined
              type="number"
              style="top: 69.5%;left: 56.1%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.b7"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) B7"
              :class="{ error: errors.has('(Schéma) B7') }"
              outlined
              type="number"
              style="top: 82.8%;left: 56.1%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.c1"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) C1"
              :class="{ error: errors.has('(Schéma) C1') }"
              outlined
              type="number"
              style="top: 10.2%;left: 68.5%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.c2"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) C2"
              :class="{ error: errors.has('(Schéma) C2') }"
              outlined
              type="number"
              style="top: 20.5%;left: 68.5%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.c3"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) C3"
              :class="{ error: errors.has('(Schéma) C3') }"
              outlined
              type="number"
              style="top: 31.3%;left: 68.5%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.c4"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) C4"
              :class="{ error: errors.has('(Schéma) C4') }"
              outlined
              type="number"
              style="top: 42.5%;left: 68.5%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.c5"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) C5"
              :class="{ error: errors.has('(Schéma) C5') }"
              outlined
              type="number"
              style="top: 56.1%;left: 68.5%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.c6"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) C6"
              :class="{ error: errors.has('(Schéma) C6') }"
              outlined
              type="number"
              style="top: 69.5%;left: 68.5%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.c7"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) C7"
              :class="{ error: errors.has('(Schéma) C7') }"
              outlined
              type="number"
              style="top: 82.8%;left: 68.5%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.d1"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) D1"
              :class="{ error: errors.has('(Schéma) D1') }"
              outlined
              type="number"
              style="top: 10.2%;left: 80.1%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.d2"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) D2"
              :class="{ error: errors.has('(Schéma) D2') }"
              outlined
              type="number"
              style="top: 20.5%;left: 80.1%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.d3"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) D3"
              :class="{ error: errors.has('(Schéma) D3') }"
              outlined
              type="number"
              style="top: 31.3%;left: 80.1%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.d4"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) D4"
              :class="{ error: errors.has('(Schéma) D4') }"
              outlined
              type="number"
              style="top: 42.5%;left: 80.1%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.d5"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) D5"
              :class="{ error: errors.has('(Schéma) D5') }"
              outlined
              type="number"
              style="top: 69.5%;left: 80.1%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.d6"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) D6"
              :class="{ error: errors.has('(Schéma) D6') }"
              outlined
              type="number"
              style="top: 82.8%;left: 80.1%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.e"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) E"
              :class="{ error: errors.has('(Schéma) E') }"
              outlined
              type="number"
              style="top: 18.9%;left: 91.1%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.f"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) F"
              :class="{ error: errors.has('(Schéma) F') }"
              outlined
              type="number"
              style="top: 37.5%;left: 91.1%;"
              height="100%"
              class="medium"
            />

            <v-text-field
              v-model="form.g"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) G"
              :class="{ error: errors.has('(Schéma) G') }"
              outlined
              type="number"
              style="top: 75.5%;left: 91.1%;"
              height="100%"
              class="medium"
            />
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CorsetStepOne",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      dropdowns: "dropdowns/getCorsetOptions"
    })
  },
  created() {
    this.$validator = this.parentValidator;
  },
  methods: {
    // Clear mesures fields
    clearMesuresFields() {
      this.form.type_measurement = null;
      this.form.idc_radio = false;
      this.form.idc_sternal_support = false;
      this.form.idc_bi_clavicular_support = false;
      this.form.lombar = null;
      this.form.observation = null;
    }
  }
};
</script>

<style lang="scss">
.corset-step-one {
  .img-container {
    position: relative;
    display: inline-block;
    margin: auto;
    img {
      height: 100%;
      width: 100%;
      // min-width: 800px;
      @media (max-width: 800px) {
        min-width: auto;
      }
    }
    .v-input {
      position: absolute;
      width: 12.2%;
      height: 14.6%;
      @media (max-width: 800px) {
        height: 14.6%;

        &.medium {
          width: 9.2%;
          height: 9.1%;
          .v-input__control {
            .v-input__slot fieldset {
              border-color: transparent;
            }
          }
        }
      }
      .v-input__control {
        height: 100%;
        .v-input__slot {
          min-height: auto;
        }
      }
    }
  }
  .v-btn {
    background-color: #006064 !important;
    color: white !important;
  }
}
</style>
